import { HStack } from '@chakra-ui/core';
import React from 'react';
import { QuestionClearButton } from './QuestionClearButton';
import { QuestionSaveButton } from './QuestionSaveButton';
import { QuestionSingleLanguageSelector } from './QuestionSingleLanguageSelector';
import { QuestionTemplateNameInput } from './QuestionTemplateNameInput';

export const FormBuilderHeader = React.memo(function FormBuilderHeader() {
  return (
    <HStack flex={1} flexGrow={0} display="flex" pr={4}>
      <QuestionTemplateNameInput />
      <QuestionSingleLanguageSelector />
      <QuestionClearButton />
      <QuestionSaveButton />
    </HStack>
  );
});
